<div class="row row-cols-1 row-cols-md-3">
  <div class="col mt-0 partner-offer-padding" *ngFor="let offer of offers$ | async">
    <div class="offer-card cursor-pointer" [routerLink]="['/partner-offers/details', offer.OfferId]">
      <div class="offer-image-wrapper" [class.locked]="offer.Locked">
        <img [src]="offer.OfferImage | contentImage: '6'" alt="" class="offer-image" />
        <div class="company-logo-wrapper" *ngIf="offer.CompanyImage" [class.locked]="offer.Locked">
          <img [src]="offer.CompanyImage | contentImage: '6'" alt="{{ offer.CompanyName }}" class="company-logo" />
        </div>
        <div *ngIf="offer.Locked" class="lock-badge">
          <span class="material-icons">lock</span>
        </div>
      </div>
      <div class="product-info">
        <p class="company-name mb-0">{{ offer.CompanyName }}</p>
        <p class="offer-title mb-0">{{ offer.OfferName }}</p>
      </div>
    </div>
  </div>
</div>
